<template>
  <div class="mb-2 w-full min-h-96 relative">
    <label class="hidden flex flex-row font-bold text-left ml-4 px-2.5 text-center block mb-2 text-lg text-gray-900 ">
      <div class="w-full">{{ labels["LABEL_RECIPE_TITLE"][lg] }}</div>
    </label>

    <div class="w-full items-center flex flex-row mb-3 grid grid-cols-3">
      <div class="mb-2 w-full py-2 flex items-center justiy-start" role="group">
        <button type="button"
          class="ml-3 flex items-center justify-left px-4 py-1 text-sm font-medium text-white rounded-lg bg-gray-700 hover:bg-gray-800 focus:ring-4 focus:ring-gray-300   focus:outline-none "
          @click="onOpenCreateSection">
          <i class="fa-solid fa-plus mr-2" />
          Ajouter une section
        </button>
      </div>
      <div v-if='config?.displaySuppliersPane != false' class="flex items-center justiy-start">
        <label class="font-semibold mr-3"> Volume de référence </label>
        <div class="w-48 text-left">
          <ContentInput :id="`content-recipe-text`" :ref="`content-recipe-text`" :config="item"
            :label="item.label && item.label[lg]" :is-button="item.isButton" :value="reference"
            @value-changed="onValueTotalChanged" />
        </div>
      </div>
    </div>
    <div>
      <div class="w-full flex">
        <div class="w-full border">
          <div class="w-full bg-gray-700 text-white font-bold">Composition</div>

          <div class="w-full flex flex-col" v-for="(section, section_index) in sections" :key="section.id">
            <div class="bg-purple-200 h-8 w-full flex flex-row items-center justify-between px-2">
              <div class="flex flex-row items-center">
                <div class="font-bold">{{ section?.name }}</div>
                <div class="w-auto flex w-full items-center justify-end w-16 px-3">
                  <div href="#"
                    class="flex justify-end cursor-pointer text-gray-800 hover:text-gray-900 font-bold text-lg focus:outline-none"
                    @click="onClickEditSection(section_index)">
                    <i class="fa-solid fa-pen" />
                  </div>
                </div>

                <div class="w-auto flex w-full items-center justify-end w-16 px-3">
                  <div href="#"
                    class="flex justify-end cursor-pointer text-gray-800 hover:text-gray-900 font-bold text-lg focus:outline-none"
                    @click="onClickDeleteSection(section_index)">
                    <i class="fa-solid fa-xmark" />
                  </div>
                </div>
              </div>
              <button type="button"
                class="max-w-48 flex items-center justify-left px-4 py-1 text-xs font-medium text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300   focus:outline-none "
                @click="onOpenList(section)">
                <i class="fa-solid fa-plus mr-2" />
                {{ labels["BUTTON_ADD"][lg] }}
              </button>
            </div>
            <draggable ghost-class="ghost"
              class="w-full min-h-64 border-1 border-solid items-start flex flex-col bg-white mb-3 border-gray-300 p-2"
              class2="list-group mt-2 w-full h-12  bg-gray-50 border border-gray-200 rounded-lg shadow     flex flex-row justify-center"
              :list="section.lines" item-key="id" @start="drag = true" @end="drag = false">
              <template #item="{ element, index }">
                <div
                  class="cursor-pointer list-group mt-2 w-full border rounded-lg shadow   flex flex-row justify-center"
                  :class="{
                    'border-blue-600 border-4  bg-blue-50 ': selectedItem == index && selectedSection == section_index,
                    'border-gray-200  bg-gray-100 ': selectedItem != index || selectedSection != section_index,
                  }" @click="onSelectItem(section_index, index)">
                  <div class="flex flex-col items-center w-full pl-2">
                    <div class="h-12 flex flex-row items-center w-full pr-6 py-3 mb-3 mt-2">
                      <div class="w-full flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 pr-2 text-sm" viewBox="0 0 320 512">
                          <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                          <path
                            d="M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z" />
                        </svg>
                        <label class="w-full pr-3 text-left block text-sm font-bold text-gray-900 ">
                          {{ element?.item?.name }}
                        </label>

                        <label v-if="config?.displaySuppliersPane != false"
                          class="w-64 pr-3 text-left block text-sm italic text-gray-900 ">
                          {{ getCounter(element) }}
                        </label>
                        <div class="w-48" v-if="config?.displaySuppliersPane != false">
                          <ContentInput :id="`content-recipe-text-${element.type_id}-${index}`"
                            :ref="`content-recipe-text-${element.type_id}-${index}`" :config="item" :index="index"
                            :section_index="section_index" :label="item.label && item.label[lg]"
                            :is-button="item.isButton" format="percent"
                            :placeholder="item.placeholder && item.placeholder[lg]" :value="element.quantity"
                            @value-changed="onValueChanged" />
                        </div>
                      </div>

                      <div class="w-auto flex w-full items-center justify-end">
                        <div class="w-auto flex flex-row items-center justify-center">
                          <div class="w-auto flex w-full items-center justify-end w-16 px-3">
                            <div href="#"
                              class="flex justify-end cursor-pointer text-gray-800 hover:text-gray-900 font-bold text-lg focus:outline-none"
                              @click="onClickMinus(section_index, element)">
                              <i class="fa-solid fa-xmark" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </draggable>
          </div>
        </div>
        <div v-if="supplier != false && config?.displaySuppliersPane != false" class="w-full border">
          <div class="w-full bg-gray-700 text-white font-bold">Produits Fournisseurs</div>
          <draggable ghost-class="ghost"
            class="w-full min-h-96 border-1 border-solid items-start flex flex-col bg-white mb-3 border-gray-300 p-6"
            class2="list-group mt-2 w-full h-12  bg-gray-50 border border-gray-200 rounded-lg shadow     flex flex-row justify-center"
            :list="products" item-key="id" @start="drag = true" @end="drag = false">
            <template #item="{ element }">
              <div
                class="cursor-pointer list-group mt-2 w-full bg-gray-50 border border-gray-200 rounded-lg shadow   flex flex-row justify-center">
                <div class="flex flex-col items-center w-full pl-2">
                  <div class="h-16 flex flex-row items-center w-full pr-3 mb-1">
                    <div class="w-full flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" class="hidden h-16 w-16 pr-2 text-sm"
                        viewBox="0 0 320 512">
                        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                        <path
                          d="M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z" />
                      </svg>
                      <div class="w-full flex items-center mr-6 text-left">
                        <img class="h-6 w-6 mr-3" :src="`${host_media}${element?.supplier_image_id}?icon=true`" />
                        <label class="w-36 text-ellipsis pr-3 text-left text-sm font-bold text-gray-900  truncate">
                          {{ element?.supplier_name?.toUpperCase() }}
                        </label>
                      </div>

                      <div class="w-full flex items-center mr-6 text-left">
                        <img class="h-10 w-10 mr-3" :src="`${host_media}${element?.image_id}?icon=true`" />
                        <label class="pr-3 text-left text-sm font-bold text-gray-900  truncate flex flex-col">
                          <span class="w-48 text-ellipsis"> {{ element.name }}</span> <small>{{ element?.brand_name
                            }}</small>
                        </label>
                      </div>



                      <div class="w-96 pt-1   flex flex-col">
                        <div
                          class="flex flex-row items-center w-full pr-3 py-1 mt-1 justify-end border-b border-green-100">
                          <span v-if="element?.entity_id?.includes('66a4a19c8d43c894c147758a')"
                            class="bg-blue-100 text-blue-800 text-xs font-semibold me-2 px-2.5 py-0.5 rounded-full  ">Alsace</span>
                          <span v-if="element?.entity_id?.includes('66a4a1cb8d43c894c147758b')"
                            class="bg-indigo-100 text-indigo-800 text-xs font-semibold me-2 px-2.5 py-0.5 rounded-full  ">Sologne</span>
                        </div>

                        <div
                          class="flex flex-row items-center w-full pr-3 py-1 mt-1 justify-end border-b border-green-100">
                          <label class="pr-3 w-20  text-right text-xs font-semibold text-gray-800 "> {{ element.price }}
                            €/kg </label>

                          <label class="relative inline-flex items-center cursor-pointer">
                            <input v-model="filtered[element._id]" type="checkbox" value="" class="sr-only peer"
                              @change="onSwitchChange(element._id)" />
                            <div
                              class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300  rounded-full peer  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-blue-600" />
                            <span class="ml-3 text-sm font-medium text-gray-900 ">
                              {{ filtered[element?._id] ? "inclus" : "exclus" }}
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </draggable>

          <div v-if="products?.length == 0">Selectionner un élement</div>
        </div>
      </div>
    </div>
  </div>
  <ItemDeleteModal :input="inputItemDelete" @close="OnItemDeleteCancel" @confirm="OnItemDeleteConfirm" />
  <CreateSectionModal :input="itemSection" @close="onOpenCloseSection" @validate="onOpenConfirmSection"
    :refresh="refresh" />

  <SelectIngredientModal @close="onSelectIngredientClose" @select="onSelectIngredientSelect" :refresh="refresh"
    :category="selectCategory" :input="itemModal" />
</template>

<script>
/*
  
  
  
     
  
  
  
  
  
  
  
  
  
  */

import { v4 as uuidv4 } from "uuid";
import ContentInput from "@/components/content/ContentInput.vue";
import SelectIngredientModal from "@/components/modals/SelectIngredientModal5.vue";
import CreateSectionModal from "@/components/modals/CreateSectionModal.vue";
import ItemDeleteModal from "@/components/modals/ItemDeleteModal.vue";

import draggable from "vuedraggable";
//import Multiselect from '@vueform/multiselect'
import labels from "@/assets/lg/content-composer.json";
import { Dropdown } from "flowbite";
import { Modal } from "flowbite";
import service from "@/services/FullService.vue";
import { mapGetters } from "vuex";

export default {
  name: "ContentRecipeComposer",
  components: {
    SelectIngredientModal,
    draggable,
    ContentInput,
    ItemDeleteModal,
    CreateSectionModal,
  },
  props: {
    id: String,
    label: String,

    placeholder: String,
    required: Boolean,
    supplier: Boolean,
    value: Object,
    parent: Object,
    volume: Object,
    config: Object,
  },
  data() {
    return {
      output: [],
      refresh: "",
      reference: {
        value: "10",
        unit: "kg",
      },
      filtered: {},
      labels: labels,
      lg: "FR",
      drag: false,
      products: [],
      products_per_entity: {},
      itemSection: {
        id: "",
        name: "Quantité",
      },

      sections: [
        {
          id: "1",
          name: "article 1",
          lines: [],
        },
        {
          id: "2",
          name: "article 2",
          lines: [],
        },
      ],

      item: {
        id: "",
        name: {
          FR: "Quantité",
          EN: "Quantitté",
        },
        options: {},
        data: "val",
        format: "percent",
        prefix: false,
      },
      createSectionModal: null,
      quantity: { value: "100", unit: "kg" },
      addIngredientModal: null,

      confirmationDeleteModal: null,
      inputItemDelete: null,
      el_dropdown: null,
      dropdowns: [],
      lines: [],
      itemModal: null,
      mode: "stock",
      enabled: true,
      selectedLang: "fr",
      selectCategory: null,
      selectedItem: null,
      selectedSection: null,
      dragging: false,
    };
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    },
  },
  watch: {
    volume: async function () { },
    parent: async function () {
      /*
      let product = await service.getDataId("raw-products", this.parent, this.user?.token, { fields: "id,recipe" });
     
      let stocks = await service.getData("inbound-stock/summary", this.user?.token, {});

      for (let i = 0; i < product?.recipes?.length; i++) {
        let item = product.items.find(function (a) {
          return a._id == product.recipe[i].type_id;
        });

        let stock = stocks.records.find(function (a) {
          return a._id == product.recipe[i].type_id;
        });

        if (stock != undefined) product.recipe[i].stock = stock.count;
        else product.recipe[i].stock = -1;

        if (item != undefined) product.recipe[i].type = item;
      }
*/
      this.lines = []; //product.recipes;
    },

    lines: function () { },
    value: function () {
      //   this.output = val;
    },
  },
  mounted() {
    if (this.value != undefined) {
      this.sections = this.value?.sections;
      this.reference = this.value?.reference;
    }

    const modalEl = document.getElementById("select-ingredient-modal-5");
    this.addIngredientModal = new Modal(modalEl, {
      placement: "center",
    });

    const modalEl4 = document.getElementById("create-section-modal");
    this.createSectionModal = new Modal(modalEl4, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl5 = document.getElementById("delete-item-modal");
    this.confirmationDeleteModal = new Modal(modalEl5, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });
  },

  methods: {
    ShowDeleteConfirmation(index, item) {
      let inputItemDelete = {
        id: item._id,
        item_id: index,
        name: "Nom",
        active: false,
        count: null,
        root: "section",
        action: "delete-ingredient-section",
        title: "Section : " + item.name,
        label: "Confirmer le nom de la section :",
        placeholder: "Nom de section :",
        description: "La Suppression de la section entrainera la suppression des ingrédients, packaging",
      };
      this.inputItemDelete = inputItemDelete;
      this.confirmationDeleteModal.show();
    },
    OnItemDeleteCancel: function () {
      this.confirmationDeleteModal.hide();
    },
    OnItemDeleteConfirm: async function (event) {
      function removeItemOnce(arr, index) {
        if (index == undefined) return arr;
        if (index > -1) {
          arr.splice(index, 1);
        }
        return arr;
      }
 

      if (event.action == "delete-ingredient-section") {
        this.sections = removeItemOnce(this.sections, event?.source?.item_id);
      }

      /*  */

      //   this.lines = this.output;
      //

      this.confirmationDeleteModal.hide();
    },

    getCounter: function (item) {
      if (item.products == undefined) return "Pas de fournisseur";

      let keys = Object.keys(item.products);
      let n = 0;
      for (let i = 0; i < keys.length; i++) {
        if (item.products[keys[i]]) n++;
      }
      if (n == 0) return "Pas de fournisseur";
      if (n == 1) return "1 fournisseur";

      return n + " fournisseurs";
    },

    onValueChanged: function (val) {
      this.sections[val.section_index].lines[val.index].quantity = val.value_full;
    },

    onValueTotalChanged: function (val) {
      this.reference = val.value;
    },

    onSwitchChange: async function (id) {
      if (this.sections[this.selectedSection].lines[this.selectedItem].products == undefined) this.sections[this.selectedSection].lines[this.selectedItem].products = {};
      this.sections[this.selectedSection].lines[this.selectedItem].products[id] = this.filtered[id];
    },
    updateSupplierProducts: async function (section, index) {


      if (index < 0) return;
      if (section?.lines[index] == undefined) return;

      let id = section.lines[index].item_id;
      let products = await service.getData("data-sources/684d453798135e80d1438e11/records", this.user?.token, { product_id: id });

      if (section.lines[this.selectedItem].products == undefined) section.lines[this.selectedItem].products = {};

      for (let i = 0; i < products?.records.length; i++) {
        if (section.lines[this.selectedItem].products[products.records[i]._id] == undefined) {
          section.lines[this.selectedItem].products[products.records[i]._id] = true;
        }
        this.filtered[products.records[i]._id] = section.lines[this.selectedItem].products[products.records[i]._id].toString();
      }
      this.products = products.records;

      
    },

    onSelectItem: async function (section_index, index) {
      // A revoir pour la sélection  des Produits

      if (section_index == undefined) return;
      this.selectedItem = index;
      this.selectedSection = section_index;

      await this.updateSupplierProducts(this.sections[section_index], index);
    },

    calcRatioStyle: function (needed, stock) {
      if (needed == "") {
        return "width:0%;";
      }

      if (stock == "-1") {
        return "width:0%;";
      }

      let ratio = (parseFloat(needed) * 100) / parseFloat(stock);
      if (ratio > 99 && ratio < 100) {
        return "width: " + ratio.toFixed(0) + "%;background-color:orange";
      }

      if (ratio < 100) {
        return "width: " + ratio.toFixed(0) + "%;background-color:green";
      }
      return "width:100%;background-color:red";
    },

    checkPourcent: function (event, index) {
      event.stopPropagation();

      if (this.lines[index].value > 100) {
        this.lines[index].error = true;
      } else this.lines[index].error = false;

      if (this.lines[index].display == undefined) this.lines[index].display = 1;
      this.BuildIngredientText();
    },
    ratio: function (el) {
      if (this.volume == undefined) return "";
      if (this.volume.value == undefined) return "";
      if (this.volume.value == "") return "";
      return ((parseFloat(el.quantity.value) * parseFloat(this.volume?.value)) / 100).toFixed(2) + this.volume?.unit;
    },
    getIndex: function (id) {
      let index = this.lines.findIndex(function (el) {
        return el.id == id;
      });

      return index;
    },
    selectLanguage: function (lg) {
      this.selectedLang = lg;
      this.BuildIngredientText();
    },
    BuildIngredientText: function () {
      let text = "";
      for (let i = 0; i < this.lines.length; i++) {
        if (text != "") text = text + ", ";
        let tagStart = "";
        let tagEnd = "";

        if (this.lines[i].options) {
          if (this.lines[i].options.bold) {
            tagStart = tagStart + "<b>";
            tagEnd = "</b>" + tagEnd;
          }
          if (this.lines[i].options.italic) {
            tagStart = tagStart + "<i>";
            tagEnd = "</i>" + tagEnd;
          }
          if (this.lines[i].options.underline) {
            tagStart = tagStart + "<u>";
            tagEnd = "</u>" + tagEnd;
          }
        }
        let value = "";
        if (this.lines[i].value) {
          if (this.lines[i].options.display == 1) value = " " + this.lines[i].value + " %";
          if (this.lines[i].options.display == 2) value = " : " + this.lines[i].value + " %";
          if (this.lines[i].options.display == 3) value = " (" + this.lines[i].value + " %)";
        }
        text = text + tagStart + this.lines[i].displayName[this.selectedLang.toUpperCase()] + value + tagEnd;
      }

      return text;
    },

    getData() {
      return { reference: this.reference, sections: this.sections };
    },
    onDropdownOpen: function (index) {
      //  if (this.dropdowns[index] == undefined)
      {
        const options = {
          placement: "bottom",
          triggerType: "click",
          offsetSkidding: 0,
          offsetDistance: 10,
          delay: 300,
          onHide: () => { },
          onShow: () => { },
          onToggle: () => { },
        };
        {
          const $targetEl = document.getElementById("dropdown-unit-" + this.id + "-" + index);

          const $triggerEl = document.getElementById("dropdown-button-2-" + this.id + "-" + index);

          this.dropdowns[index] = new Dropdown($targetEl, $triggerEl, options);
        }
      }
      this.dropdowns[index].toggle();
    },
    onSelectIngredientSelect: function (event) {
      let newItem = {};

      newItem.id = uuidv4();
      newItem.item_id = event.item._id;
      newItem.item = event.item;
      newItem.quantity = {};
      newItem.quantity.unit = "%";
      newItem.quantity.value = "100";
      newItem.options = {};

      newItem.batches = [];

      let ii = 0;
      let section = this.sections.find(function (a) {
        a.index = ii++;
        return a.id == event?.section?.id;
      });

      if (section == undefined) {
        alert("Error");
        return;
      }

      if (section.lines == undefined) section.lines = [];
      //

      section.lines.push(newItem);
      this.addIngredientModal.hide();
      this.onSelectItem(section.index, section?.lines?.length - 1);
    },
    onSelectIngredientClose: function () {
      this.addIngredientModal.hide();
    },
    onOpenList: function (section) {
      this.itemModal = { section: section };
      this.refresh = Math.random().toString(36).substring(7);

      this.addIngredientModal.show();
      //  this.windowRef = window.open("https://editor-label.vercel.app/edit/" + this.selectedLabel.id, this.selectedLabel.id, "");
      //  if (!this.windowRef) return;
    },
    onOpenCreateSection: function () {
      this.itemSection = {
        mode: "create",
        name: "",
        index: null,
        title: "Ajouter un produit",
        description: "Veuillez Saisir le nom de l'article",
      };

      this.refresh = Math.random().toString(36).substring(7);

      this.createSectionModal.show();
    },
    onOpenCloseSection: function () {
      this.createSectionModal.hide();
    },
    onOpenConfirmSection: function (event) {
      if (event.mode == "create") {
        let section = {
          id: Math.random().toString(36).substring(7),
          name: event.name,
          lines: [],
        };

        if (this.sections == undefined) this.sections = [];

        this.sections.push(section);
      }
      if (event.mode == "edit") {
        this.sections[event.index].name = event.name;
      }
      this.createSectionModal.hide();
    },

    selectValue: function (tag, unit) {

      //this.output = a

      let index = this.getIndex(tag);
      if (this.lines[index] == undefined) this.lines[index] = { unit: "" };
      this.lines[index].unit = unit;

      this.dropdowns[index].toggle();
    },

    onClickEditSection: function (index) {
      let section = this.sections[index];
      this.itemSection = {
        mode: "edit",
        name: section.name,
        index: index,
        title: "Ajouter un produit",
        description: "Veuillez Saisir le nom de l'article",
      };

      this.refresh = Math.random().toString(36).substring(7);

      this.createSectionModal.show();
    },
    onClickDeleteSection: function (index) {
      this.ShowDeleteConfirmation(index, this.sections[index]);
    },

    onClickMinus: function (index, item) {
      event.stopPropagation();

      function removeItemOnce(arr, index) {
        if (index > -1) {
          arr.splice(index, 1);
        }
        return arr;
      }


      for (let i = 0; i < this.sections[index].lines.length; i++) {
        

        if (this.sections[index].lines[i].id == item.id) {
          if (this.selectedSection == index && i == this.selectedItem) {
            this.selectedItem = null;
            this.selectedSection = null;
            this.products = [];
          }

          //   this.lines = this.output;
          this.sections[index].lines = removeItemOnce(this.sections[index].lines, i);

          return;
        }
      }
    },
  },
};
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.not-draggable {
  cursor: no-drop;
}
</style>
